import axios from 'axios';

import { apiRoute } from '../../utils/api';
import {
	VIEWED_NOTIFICATION,
	TOGGLE_NOTIFICATION,
} from '../types';

export const updateNotification = (id) => {
	return dispatch => {
		const url = `${apiRoute}/dale/v1/notification/${id}`;

		return axios.patch(url,{
				'has_viewed': true
			})
			.then(res => {
				dispatch({
					type: VIEWED_NOTIFICATION,
					payload: res.data.id,
				});
			});
	}
}

export const toggleNotification = id => ({
	type: TOGGLE_NOTIFICATION,
	payload: id,
});


// WEBPACK FOOTER //
// ./src/store/notifications/actions.js